import { capitalize, formatPhone } from "shared/utils";
import { KeyValue } from "views/applications-id-report/components/KeyValue";
import { BankItem } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/verified/bank";
import { ReverifyAttempt } from "../../../ReverifySlice/types";
import { isReverifyTabAPlaceholder } from "../../../ReverifySlice/utils";

export const VerifiedReportedStats = ({
  selectedReverifyAttempt
}: {
  selectedReverifyAttempt?: ReverifyAttempt;
}) => {
  const isGroupedItems = Array.isArray(selectedReverifyAttempt);
  if (isGroupedItems || isReverifyTabAPlaceholder(selectedReverifyAttempt))
    return null;

  const hasBankAccount =
    selectedReverifyAttempt?.data != null &&
    "account" in selectedReverifyAttempt.data;
  const asBankItem = hasBankAccount
    ? (selectedReverifyAttempt as BankItem)
    : null;
  const account = asBankItem?.data.account;
  const accountDisplay = account
    ? capitalize(account.type) + " ***" + account.mask
    : null;
  const institutionName =
    asBankItem?.data.institution_metadata?.name ?? account?.name;
  const owners = asBankItem?.data.account?.owners;

  return (
    <div className="space-y-3">
      {selectedReverifyAttempt?.data &&
      "accounts" in selectedReverifyAttempt.data &&
      selectedReverifyAttempt.data.accounts[0] ? (
        <div className="space-y-3">
          <KeyValue
            label="Account ID"
            value={selectedReverifyAttempt.data.accounts[0].account_id}
          />
        </div>
      ) : null}
      {hasBankAccount ? (
        <>
          <KeyValue label="Bank account" value={accountDisplay ?? "-"} />
          <KeyValue label="Institution" value={institutionName || "-"} />
          <KeyValue label="Source bank account" value={accountDisplay ?? "-"} />
          <KeyValue
            label="Names"
            value={
              owners
                ?.flatMap((o) =>
                  o.names.map((n) =>
                    n.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase())
                  )
                )
                .join(", ") || "-"
            }
          />
          <KeyValue
            label="Phone numbers"
            value={
              owners
                ?.flatMap((o) =>
                  o.phone_numbers.map(
                    (pn) => `${formatPhone(pn.data)} ${pn.type}`
                  )
                )
                .join("\n") || "-"
            }
          />
          <KeyValue
            label="Emails"
            value={
              owners?.flatMap((o) => o.emails.map((e) => e.data)).join(", ") ||
              "-"
            }
          />
          <KeyValue
            label="Account holder address"
            value={
              owners
                ?.flatMap((o) =>
                  o.addresses.map((addr) => {
                    const { street, city, region, postal_code, country } =
                      addr.data;
                    return [street, city, region, postal_code, country]
                      .filter(Boolean)
                      .join(", ");
                  })
                )
                .filter(Boolean)
                .join("\n") || "-"
            }
          />
        </>
      ) : null}
    </div>
  );
};
